import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SDK_VERSION, init as init$1 } from '@sentry/react';
import { getIntegrationsFromOptions } from './utils/integrations.js';
/**
 * Inits the Sentry Gatsby SDK.
 */

function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.gatsby',
    packages: [{
      name: 'npm:@sentry/gatsby',
      version: SDK_VERSION
    }],
    version: SDK_VERSION
  };
  var integrations = getIntegrationsFromOptions(options);
  init$1(_objectSpread(_objectSpread({}, options), {}, {
    integrations: integrations
  }));
}

export { init };